import { render, staticRenderFns } from "./cq-card-placeholder.vue?vue&type=template&id=5b1fda4a&"
import script from "./cq-card-placeholder.vue?vue&type=script&lang=js&"
export * from "./cq-card-placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports